import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { _MatRadioGroupBase } from '@angular/material/radio';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { EUserRole } from 'src/app/domain/enum/user-role';
import { Invoice } from 'src/app/domain/invoice';
import { LastReport } from 'src/app/domain/lastReport';
import { Order } from 'src/app/domain/order';
import { YearlyFigures } from 'src/app/model/yearly-figures';
import { CompteurDto } from 'src/app/services/DTO/compteur.dto';
import { ELIMSService } from 'src/app/services/elims.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { CoreDataService } from 'src/app/tools/core-data/core-data.service';

import { BaseComponent } from '../base/base.component';

@Component({
    selector: 'app-my-chart',
    templateUrl: './my-chart.component.html',
    styleUrls: ['./my-chart.component.scss']
})
export class MyChartComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
    options: any;

    @ViewChild(MatSort) sort!: MatSort;
    dataSource = new MatTableDataSource<Invoice>();
    displayedColumns = ['InvoiceELE', 'ClientName','InvoiceDate','InvoiceCode',"Comment",  'InvoiceAmount', 'InvoicePurchaseOrder', 'InvoiceExcelFile'];

    
    constructor(
        private dialog: MatDialog,
        private invoiceService: InvoiceService,
        private coreDataService: CoreDataService,
        public CoreData: CoreData) {
        super();

    }

    ngOnInit(): void {

        this.invoiceService.getInvoices().subscribe(x => {
            this.dataSource.data=x;
        })
        
    }

    ngAfterViewInit(): void {
       
    }

    ngOnDestroy() { // It's a good practice to unsubscribe to ensure no memory leaks
        
    }

    setPO (currentInvoice : Invoice)
    {
        this.invoiceService.SetPurchaseOrderCode(currentInvoice.InvoiceCode,currentInvoice.tempInvoicePurchaseOrder).subscribe(x => {
          if (x)
          {
            currentInvoice.InvoicePurchaseOrder=currentInvoice.tempInvoicePurchaseOrder;
          }
        })
        
    }

    isPurchaseOrderValid(pattern:string,tempInvoicePurchaseOrder: string)
    {
        
        const regexp = new RegExp( pattern);
        return regexp.test(tempInvoicePurchaseOrder);

    }

    downLoadDocument(invoice: string) {
        this.invoiceService.getDocument(invoice)
            .subscribe((x: any) => {

                const url = window.URL.createObjectURL(x.body);
                const a = document.createElement('a');

                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(x.headers.get('Content-Disposition'));
                if (matches != null && matches[1]) {
                    a.download = matches[1].replace(/['"]/g, '');

                }
                a.target = '_blank';
                a.href = url;

                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox

                a.click();
                a.remove();
            });
    }
  
}
